// extracted by mini-css-extract-plugin
module.exports = {"toast-height":"48px","toast-height-multiline":"68px","toast-margin":"8px","toast-padding":"0"};